import { NgModule } from '@angular/core';
import { UserMicrosoftProfilComponent } from './user-microsoft-profil.component';
import {
  AccessRightProdTest,
  BlockPageAuthGuard,
  CanAuthenticationGuard,
  UserForbiddenGuard,
} from 'src/app/utils/authguard';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material/material.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { TeamsTableComponent } from './teams-table/teams-table.component';
import { GroupsTableComponent } from './groups-table/groups-table.component';
import { LicensesTableComponent } from './licenses-table/licenses-table.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedmailboxesTableComponent } from './sharedmailboxes-table/sharedmailboxes-table.component';

const routes = [
  {
    path: 'user365/:email',
    component: UserMicrosoftProfilComponent,
    canActivate: [
      CanAuthenticationGuard,
      AccessRightProdTest,
      BlockPageAuthGuard,
      UserForbiddenGuard,
    ],
  },
];

@NgModule({
  declarations: [
    UserMicrosoftProfilComponent,
    TeamsTableComponent,
    GroupsTableComponent,
    LicensesTableComponent,
    SharedmailboxesTableComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MaterialModule,
  ],
  exports: [
    UserMicrosoftProfilComponent,
    TeamsTableComponent,
    GroupsTableComponent,
    LicensesTableComponent,
    SharedmailboxesTableComponent,
  ],
  providers: [CanAuthenticationGuard, UserForbiddenGuard],
})
export class UserMicrosoftProfilModule {}
